"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var clerk_react_1 = require("@clerk/clerk-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var axios_1 = __importDefault(require("axios"));
var SecuredByQwilr_1 = require("@CommonFrontend/SecuredByQwilr/SecuredByQwilr");
var LinkPreview_1 = require("@CommonFrontendBackend/Project/LinkPreview");
var react_transition_group_1 = require("react-transition-group");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var Telemetry_1 = require("@CommonFrontend/Public/Telemetry/Telemetry");
var AuthenticationContext_1 = require("Public/Identity/AuthenticationContext");
var styles = __importStar(require("./PasswordProtected.css"));
var AnimatedBackground_1 = require("../AnimatedBackground/AnimatedBackground");
var AccessGateSpinner_1 = require("../AccessGateSpinner/AccessGateSpinner");
var SpringboardUserCard_1 = require("@CommonFrontend/Public/Springboard/UserCard/SpringboardUserCard");
var AuthenticationProvider_1 = __importDefault(require("Public/Identity/AuthenticationProvider"));
var bem = (0, BemBuilder_1.default)("password-protected");
var CLERK_TOKEN_TIMEOUT = 1000 * 10;
var SubmitErrors;
(function (SubmitErrors) {
    SubmitErrors["PasswordIncorrect"] = "Incorrect password for this page";
    SubmitErrors["PasswordEmpty"] = "Please enter the password for this page";
    SubmitErrors["Server"] = "Something went wrong, please try again later.";
})(SubmitErrors || (SubmitErrors = {}));
var track = function (event, properties) {
    Telemetry_1.Telemetry.getInstance().track(event, properties);
};
var handleSubmit = function (values, url, onSuccess, getToken, useSpringboardExperience) { return __awaiter(void 0, void 0, void 0, function () {
    var axiosInstance, headersConfig, clerkToken, error_1, error_2, err;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                axiosInstance = axios_1.default.create({
                    baseURL: url,
                    withCredentials: true,
                });
                headersConfig = {};
                if (!useSpringboardExperience) return [3, 4];
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                return [4, Promise.race([
                        getToken(),
                        new Promise(function (resolve) {
                            setTimeout(function () {
                                console.error("Fetching Clerk user auth token timed out, fallback to unauthenticated user");
                                resolve();
                            }, CLERK_TOKEN_TIMEOUT);
                        }),
                    ])];
            case 2:
                clerkToken = _c.sent();
                if (clerkToken) {
                    headersConfig["Authorization"] = "Bearer ".concat(clerkToken);
                }
                return [3, 4];
            case 3:
                error_1 = _c.sent();
                console.error("Error getting auth token from Clerk when saving password for password protected page");
                return [3, 4];
            case 4:
                _c.trys.push([4, 6, , 7]);
                return [4, axiosInstance.post("/", { p: (_a = values.password) !== null && _a !== void 0 ? _a : "" }, { headers: headersConfig })];
            case 5:
                _c.sent();
                onSuccess();
                return [3, 7];
            case 6:
                error_2 = _c.sent();
                if (((_b = error_2.response) === null || _b === void 0 ? void 0 : _b.status) === 401) {
                    track("Used Incorrect Project Password");
                    err = (0, kaleidoscope_2.createFormSubmitErrorObject)(SubmitErrors.PasswordIncorrect);
                    err.password = !!values.password ? SubmitErrors.PasswordIncorrect : SubmitErrors.PasswordEmpty;
                    return [2, err];
                }
                return [2, (0, kaleidoscope_2.createFormSubmitErrorObject)(SubmitErrors.Server)];
            case 7: return [2];
        }
    });
}); };
var PasswordForm = function (_a) {
    var submitUrl = _a.submitUrl, onSuccess = _a.onSuccess, telemetryProperties = _a.telemetryProperties, useSpringboardExperience = _a.useSpringboardExperience;
    (0, react_1.useEffect)(function () {
        track("Qwilr Access Gate Viewed", telemetryProperties);
    }, []);
    var getToken = (0, clerk_react_1.useAuth)().getToken;
    return (react_1.default.createElement(kaleidoscope_2.FormComponent, { onSubmit: function (values) { return handleSubmit(values, submitUrl, onSuccess, getToken, useSpringboardExperience); } },
        react_1.default.createElement(kaleidoscope_2.FormContext.Consumer, null, function (context) {
            return (react_1.default.createElement("div", { className: styles.form },
                react_1.default.createElement(kaleidoscope_2.FormTextInput, { name: "password", type: "password", placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022", label: "Password", labelHidden: true, autoFocus: true, initialValue: "", validate: function (value) {
                        if (!value) {
                            return SubmitErrors.PasswordEmpty;
                        }
                    } }),
                react_1.default.createElement(kaleidoscope_1.Expandable, { onEnter: utils_1.forceReflow, expanded: (context === null || context === void 0 ? void 0 : context.submitError) === SubmitErrors.Server }, function (_a) {
                    var expandableElementRef = _a.expandableElementRef;
                    return (react_1.default.createElement("div", { ref: expandableElementRef },
                        react_1.default.createElement(kaleidoscope_1.Alert, { heading: "Error", alertType: kaleidoscope_1.AlertType.Error }, SubmitErrors.Server)));
                }),
                react_1.default.createElement(kaleidoscope_2.FormSubmitButton, { width: "full" }, "Continue")));
        })));
};
var PasswordProtected = function (props) {
    var _a;
    var continueUrl = encodeURIComponent(props.pageUrl);
    var imageSrc = props.previewImage ? props.previewImage : LinkPreview_1.LINK_PREVIEW_DEFAULT_URL;
    var _b = (0, clerk_react_1.useAuth)(), isLoaded = _b.isLoaded, isSignedIn = _b.isSignedIn, signOut = _b.signOut;
    var _c = __read((0, react_1.useState)(false), 2), ready = _c[0], setReady = _c[1];
    var useSpringboardExperience = (_a = props.useSpringboardExperience) !== null && _a !== void 0 ? _a : true;
    (0, react_1.useEffect)(function () {
        if (useSpringboardExperience) {
            setReady(isLoaded);
        }
        else {
            setReady(true);
        }
    }, [isLoaded, useSpringboardExperience]);
    var getAuthUrl = (0, AuthenticationContext_1.useAuthenticationContext)().getAuthUrl;
    var loginUrl = getAuthUrl("login", continueUrl, AuthenticationContext_1.AuthenticationOrigin.PasswordProtection);
    if (ready) {
        props.setPulsing(false);
    }
    var handlePasswordSuccess = function () {
        track("Entered Project Password", { saved_password: useSpringboardExperience ? isSignedIn : false });
        props.setPageUnlocked(true);
        props.setPulsing(true);
        setTimeout(function () {
            props.setPulsing(false);
            window.location.reload();
        }, kaleidoscope_3.AnimationDuration.Long + 1000);
    };
    var handleClickSwitchAccounts = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    track("Clicked Switch Springboard Account", {
                        source: "password protection",
                    });
                    return [4, signOut()];
                case 1:
                    _a.sent();
                    window.location.href = loginUrl;
                    return [2];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: "password-protected-container" },
        react_1.default.createElement(AccessGateSpinner_1.AccessGateSpinner, { loading: !ready, pageUnlocked: props.pageUnlocked, className: "password-protected__spinner" }),
        react_1.default.createElement(react_transition_group_1.Transition, { mountOnEnter: true, unmountOnExit: true, in: ready && !props.pageUnlocked, timeout: kaleidoscope_3.AnimationDuration.Long, onEnter: utils_1.forceReflow }, function (status) { return (react_1.default.createElement("div", { className: bem(), "data-status": status },
            react_1.default.createElement(kaleidoscope_1.Card, { elevation: 1, className: bem("card-body") },
                react_1.default.createElement("div", { className: bem("image-container") },
                    react_1.default.createElement("img", { className: bem("image"), alt: "Qwilr page preview", src: imageSrc, width: 1200, height: 627 })),
                react_1.default.createElement("div", { className: bem("password-card") },
                    useSpringboardExperience && (react_1.default.createElement(clerk_react_1.SignedIn, null,
                        react_1.default.createElement(SpringboardUserCard_1.SpringboardUserCard, { onClickSwitchAccounts: handleClickSwitchAccounts }))),
                    react_1.default.createElement("div", { className: bem("password-card-description") },
                        react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, secondary: true, level: "5", align: "center" }, "Enter the page password"),
                        useSpringboardExperience && (react_1.default.createElement(clerk_react_1.SignedIn, null, props.invalidSavedPassword ? (react_1.default.createElement(kaleidoscope_1.Alert, { alertType: kaleidoscope_1.AlertType.Error, heading: "Password changed", className: bem("password-card-alert") }, "The page owner has changed the password for this page. Please enter the new password")) : (react_1.default.createElement(kaleidoscope_1.Text, { size: "s", align: "center" }, "Because you're logged in you won't have to enter the password for this page again"))))),
                    react_1.default.createElement(PasswordForm, { useSpringboardExperience: useSpringboardExperience, submitUrl: props.pageUrl, onSuccess: handlePasswordSuccess, telemetryProperties: {
                            type: "password protection",
                            had_old_password: props.invalidSavedPassword,
                        } }))),
            useSpringboardExperience && (react_1.default.createElement(clerk_react_1.SignedOut, null,
                react_1.default.createElement("div", { className: bem("login-prompt") },
                    "Have a Qwilr Springboard account?",
                    " ",
                    react_1.default.createElement(kaleidoscope_1.Link, { onClick: function () { return track("Clicked Password Protection Login"); }, href: loginUrl, target: "_self" }, "Log in")))))); }),
        react_1.default.createElement(react_transition_group_1.Transition, { mountOnEnter: true, unmountOnExit: true, in: !props.pageUnlocked, timeout: kaleidoscope_3.AnimationDuration.Long, onEnter: utils_1.forceReflow }, function (status) { return (react_1.default.createElement("div", { className: bem("secured-by-qwilr"), "data-status": status },
            react_1.default.createElement(SecuredByQwilr_1.SecuredByQwilr, { utmParams: "utm_source=public_page&utm_medium=password_protected&utm_campaign=secured_by_qwilr" }))); })));
};
var WrappedPasswordProtected = function (props) {
    var _a = __read((0, react_1.useState)(true), 2), backgroundPulsing = _a[0], setBackgroundPulsing = _a[1];
    var _b = __read((0, react_1.useState)(false), 2), pageUnlocked = _b[0], setPageUnlocked = _b[1];
    var authProviderProps = props.authProviderProps, remainingProps = __rest(props, ["authProviderProps"]);
    return (react_1.default.createElement(AuthenticationProvider_1.default, __assign({}, authProviderProps),
        react_1.default.createElement(AnimatedBackground_1.AnimatedBackground, { pulsing: backgroundPulsing, pageUnlocked: pageUnlocked },
            react_1.default.createElement(PasswordProtected, __assign({}, remainingProps, { setPulsing: setBackgroundPulsing, setPageUnlocked: setPageUnlocked, pulsing: backgroundPulsing, pageUnlocked: pageUnlocked })))));
};
exports.default = WrappedPasswordProtected;
